// MyComponent.js
import React from 'react';
import Hero from '../../components/Hero/Hero';
import Portfolio from '../../components/Portfolio/Portfolio';
import Footer from '../../components/Footer/Footer'
import Blog from '../../components/Blog/Blog';
import Contact from '../../components/Contact/Contact';
import Experience from '../../components/Experience/Experience';
import ContributionChart from '../../components/Contributions/ContributionChart';
import Conferences from '../../components/Conferences/Conferences';
import ThemeToggle from '../../components/ThemeToggle/ThemeToggle';
import PianoPieces from '../../components/Piano/PianoPieces';


function Home() {
    return (
        <div className='grid1'>
            <ThemeToggle />
            <Hero/>
            
            <Experience/>
            <Portfolio/>
            <Blog/>
            <Conferences/>
            <PianoPieces/>
            <ContributionChart/>
            
            <Contact/>
            <Footer/>
        </div>
    );
}

export default Home;
